/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PaginatedModelOfPriceSetupModel } from '../model/paginatedModelOfPriceSetupModel';
import { PriceDto } from '../model/priceDto';
import { PriceSetupDto } from '../model/priceSetupDto';
import { PriceSetupModel } from '../model/priceSetupModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SmsPriceSetupService {

    protected basePath = 'http://10.1.1.123:30116';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsPriceSetupDeleteSmsPriceSetup(id?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public smsPriceSetupDeleteSmsPriceSetup(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public smsPriceSetupDeleteSmsPriceSetup(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public smsPriceSetupDeleteSmsPriceSetup(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<boolean>(`${this.basePath}/api/SmsPriceSetup/DeleteSmsPriceSetup`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param searchword 
     * @param orderbylowestprices 
     * @param skip 
     * @param take 
     * @param routeGroupName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsPriceSetupGetAll(creatorId?: string, searchword?: string, orderbylowestprices?: boolean, skip?: number, take?: number, routeGroupName?: string, observe?: 'body', reportProgress?: boolean): Observable<PriceSetupDto>;
    public smsPriceSetupGetAll(creatorId?: string, searchword?: string, orderbylowestprices?: boolean, skip?: number, take?: number, routeGroupName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PriceSetupDto>>;
    public smsPriceSetupGetAll(creatorId?: string, searchword?: string, orderbylowestprices?: boolean, skip?: number, take?: number, routeGroupName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PriceSetupDto>>;
    public smsPriceSetupGetAll(creatorId?: string, searchword?: string, orderbylowestprices?: boolean, skip?: number, take?: number, routeGroupName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (searchword !== undefined && searchword !== null) {
            queryParameters = queryParameters.set('searchword', <any>searchword);
        }
        if (orderbylowestprices !== undefined && orderbylowestprices !== null) {
            queryParameters = queryParameters.set('orderbylowestprices', <any>orderbylowestprices);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }
        if (routeGroupName !== undefined && routeGroupName !== null) {
            queryParameters = queryParameters.set('routeGroupName', <any>routeGroupName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PriceSetupDto>(`${this.basePath}/api/SmsPriceSetup/GetAll`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param startIndex 
     * @param count 
     * @param searchword 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsPriceSetupGetAllRecordByCreatorId(creatorId?: string, startIndex?: number, count?: number, searchword?: string, observe?: 'body', reportProgress?: boolean): Observable<PriceSetupDto>;
    public smsPriceSetupGetAllRecordByCreatorId(creatorId?: string, startIndex?: number, count?: number, searchword?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PriceSetupDto>>;
    public smsPriceSetupGetAllRecordByCreatorId(creatorId?: string, startIndex?: number, count?: number, searchword?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PriceSetupDto>>;
    public smsPriceSetupGetAllRecordByCreatorId(creatorId?: string, startIndex?: number, count?: number, searchword?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }
        if (searchword !== undefined && searchword !== null) {
            queryParameters = queryParameters.set('searchword', <any>searchword);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PriceSetupDto>(`${this.basePath}/api/SmsPriceSetup/GetAllRecordByCreatorId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param smsChannel 
     * @param creatorId 
     * @param routename 
     * @param mcc 
     * @param mnc 
     * @param skip 
     * @param take 
     * @param routeGroupName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsPriceSetupGetAllWithNetworkDetails(smsChannel?: number, creatorId?: string, routename?: string, mcc?: string, mnc?: string, skip?: number, take?: number, routeGroupName?: string, observe?: 'body', reportProgress?: boolean): Observable<PaginatedModelOfPriceSetupModel>;
    public smsPriceSetupGetAllWithNetworkDetails(smsChannel?: number, creatorId?: string, routename?: string, mcc?: string, mnc?: string, skip?: number, take?: number, routeGroupName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedModelOfPriceSetupModel>>;
    public smsPriceSetupGetAllWithNetworkDetails(smsChannel?: number, creatorId?: string, routename?: string, mcc?: string, mnc?: string, skip?: number, take?: number, routeGroupName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedModelOfPriceSetupModel>>;
    public smsPriceSetupGetAllWithNetworkDetails(smsChannel?: number, creatorId?: string, routename?: string, mcc?: string, mnc?: string, skip?: number, take?: number, routeGroupName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (smsChannel !== undefined && smsChannel !== null) {
            queryParameters = queryParameters.set('smsChannel', <any>smsChannel);
        }
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (routename !== undefined && routename !== null) {
            queryParameters = queryParameters.set('routename', <any>routename);
        }
        if (mcc !== undefined && mcc !== null) {
            queryParameters = queryParameters.set('mcc', <any>mcc);
        }
        if (mnc !== undefined && mnc !== null) {
            queryParameters = queryParameters.set('mnc', <any>mnc);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }
        if (routeGroupName !== undefined && routeGroupName !== null) {
            queryParameters = queryParameters.set('routeGroupName', <any>routeGroupName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatedModelOfPriceSetupModel>(`${this.basePath}/api/SmsPriceSetup/GetAllWithNetworkDetails`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsPriceSetupGetPriceSetupById(id?: string, observe?: 'body', reportProgress?: boolean): Observable<PriceSetupModel>;
    public smsPriceSetupGetPriceSetupById(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PriceSetupModel>>;
    public smsPriceSetupGetPriceSetupById(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PriceSetupModel>>;
    public smsPriceSetupGetPriceSetupById(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PriceSetupModel>(`${this.basePath}/api/SmsPriceSetup/GetPriceSetupById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsPriceSetupInsertSmsPriceSetup(model: PriceSetupModel, observe?: 'body', reportProgress?: boolean): Observable<PriceSetupModel>;
    public smsPriceSetupInsertSmsPriceSetup(model: PriceSetupModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PriceSetupModel>>;
    public smsPriceSetupInsertSmsPriceSetup(model: PriceSetupModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PriceSetupModel>>;
    public smsPriceSetupInsertSmsPriceSetup(model: PriceSetupModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smsPriceSetupInsertSmsPriceSetup.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<PriceSetupModel>(`${this.basePath}/api/SmsPriceSetup/InsertSmsPriceSetup`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsPriceSetupModelNomalization(observe?: 'body', reportProgress?: boolean): Observable<PriceDto>;
    public smsPriceSetupModelNomalization(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PriceDto>>;
    public smsPriceSetupModelNomalization(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PriceDto>>;
    public smsPriceSetupModelNomalization(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<PriceDto>(`${this.basePath}/api/SmsPriceSetup/ModelNomalization`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsPriceSetupUpdateSmsPriceSetup(model: PriceSetupModel, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public smsPriceSetupUpdateSmsPriceSetup(model: PriceSetupModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public smsPriceSetupUpdateSmsPriceSetup(model: PriceSetupModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public smsPriceSetupUpdateSmsPriceSetup(model: PriceSetupModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smsPriceSetupUpdateSmsPriceSetup.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<boolean>(`${this.basePath}/api/SmsPriceSetup/UpdateSmsPriceSetup`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
